import { useTranslation } from 'react-i18next';

import { selectCurrentUser } from 'store/user/selectors';

import { useSelector } from 'hooks/store';

import step1Image from './img/InstructionStep1.png';
import step2Image from './img/InstructionStep2.png';
import step3Image from './img/InstructionStep3.png';

const BRANCH_TO_PLAN_KEY: Record<string, string> = {
    taichi: 'planName.taichi',
    wmncls: 'planName.calisthenics',
    calisthenics: 'planName.calisthenics',
    chair: 'planName.chair',
    fasting: 'planName.fasting',
    calorie: 'planName.calorie',
    default: 'planName.default',
};

const DEFAULT_PLAN_KEY = 'planName.default';

export const getPlanNameKey = (branch: string | null | undefined): string => {
    if (!branch) {
        return DEFAULT_PLAN_KEY;
    }

    return BRANCH_TO_PLAN_KEY[branch] ?? DEFAULT_PLAN_KEY;
};

export const useDownloadAppCopy = () => {
    const user = useSelector(selectCurrentUser);
    const { t } = useTranslation();
    const planNameKey = getPlanNameKey(user?.branch_name);

    const instructions = [
        {
            image: step1Image,
            title: t('downloadAppPage.instructions.step1.title'),
            description: t('downloadAppPage.instructions.step1.description'),
        },
        {
            image: step2Image,
            title: t('downloadAppPage.instructions.step2.title'),
            description: t('downloadAppPage.instructions.step2.description', { planName: t(planNameKey) }),
        },
        {
            image: step3Image,
            title: t('downloadAppPage.instructions.step3.title'),
            description: t('downloadAppPage.instructions.step3.description'),
        },
    ];

    return {
        instructions,
        panel: {
            closed: t('downloadAppPage.panel.closed'),
            open: t('downloadAppPage.panel.open'),
        },
        main: {
            title: t('downloadAppPage.main.title', { planName: t(planNameKey) }),
            subtitle: t('downloadAppPage.main.subtitle'),
            description: t('downloadAppPage.main.description'),
        },
        support: {
            title: t('downloadAppPage.support.title'),
            description: t('downloadAppPage.support.description'),
            button: t('downloadAppPage.support.button'),
            link: t('downloadAppPage.support.link'),
        },
    };
};
